import React from "react"
import { cn } from "../lib/utils"

/**
 * Actinium Book logo — open book formed into an “A” monogram.
 */
export function ActiniumLogo({ size = 32, className, title = "Actinium Book", ...props }) {
  const id = React.useId().replace(/:/g, "")

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      role={title ? "img" : "presentation"}
      aria-hidden={title ? undefined : true}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <defs>
        <linearGradient id={`ab-bg-${id}`} x1="6" y1="2" x2="34" y2="38" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6366F1" />
          <stop offset="1" stopColor="#3730A3" />
        </linearGradient>
        <linearGradient id={`ab-page-${id}`} x1="12" y1="6" x2="28" y2="34" gradientUnits="userSpaceOnUse">
          <stop stopColor="#FFFFFF" />
          <stop offset="1" stopColor="#E0E7FF" />
        </linearGradient>
      </defs>

      <rect width="40" height="40" rx="10" fill={`url(#ab-bg-${id})`} />
      <rect x="1.5" y="1.5" width="37" height="37" rx="8.5" stroke="white" strokeOpacity="0.14" />

      {/* Book body cut into letter A (evenodd hole) */}
      <path
        fillRule="evenodd"
        d="M20 5.8L5.2 34.2H11.1L13.85 27.6H26.15L28.9 34.2H34.8L20 5.8ZM20 13.4L17.05 20.6H22.95L20 13.4Z"
        fill={`url(#ab-page-${id})`}
      />

      {/* Center spine fold */}
      <path d="M19.45 7.4V25.8H20.55V7.4L20 6.4L19.45 7.4Z" fill="#A5B4FC" fillOpacity="0.95" />

      {/* Open-book crossbar (A bar) */}
      <path
        d="M12.6 24.35C15.1 23.55 17.5 23.1 20 23.1C22.5 23.1 24.9 23.55 27.4 24.35V27.55C24.8 26.6 22.4 26.15 20 26.15C17.6 26.15 15.2 26.6 12.6 27.55V24.35Z"
        fill="#C7D2FE"
      />
      <path
        d="M12.6 24.35C15.1 23.55 17.5 23.1 20 23.1C22.5 23.1 24.9 23.55 27.4 24.35L26.75 25.7C24.45 24.95 22.2 24.55 20 24.55C17.8 24.55 15.55 24.95 13.25 25.7L12.6 24.35Z"
        fill="#EEF2FF"
      />

      {/* Page lines on each leg */}
      <path d="M14.35 29.4H17.6" stroke="#6366F1" strokeWidth="1.1" strokeLinecap="round" strokeOpacity="0.45" />
      <path d="M22.4 29.4H25.65" stroke="#6366F1" strokeWidth="1.1" strokeLinecap="round" strokeOpacity="0.45" />
      <path d="M15.7 12.9L17.9 18.2" stroke="#6366F1" strokeWidth="1" strokeLinecap="round" strokeOpacity="0.35" />
      <path d="M24.3 12.9L22.1 18.2" stroke="#6366F1" strokeWidth="1" strokeLinecap="round" strokeOpacity="0.35" />

      {/* Bookmark at the peak */}
      <path d="M18.65 4.35H21.35V9.7L20 8.4L18.65 9.7V4.35Z" fill="#FBBF24" />
    </svg>
  )
}
